<mf-page title="Editar pasarela">
  @if (gatewayDto) {
  <mf-gateway
    [gatewayDto]="gatewayDto"
    (save)="save($event)" />
  }
</mf-page>
